import { useState } from 'react';

import { DropdownMenu } from '../../../../cdl/DropdownMenu/DropdownMenu';
import { translate } from '../../../../common/helpers/translate.helper';
import { MfaAccessControl } from '../../hooks/useMfaAccessControl';

import { RemoveMfaConfirmationModal } from './RemoveMfaConfirmationModal';

interface MfaDropdownProps {
    methodId: string;
    accessControl: MfaAccessControl;
    userId: string;
}

export const MfaDropdown = ({ methodId, accessControl, userId }: MfaDropdownProps) => {
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    return (
        <>
            <DropdownMenu
                options={[
                    {
                        label: translate('mfa.authenticator.action.remove'),
                        onSelect: () => setIsDeleteModalOpen(true),
                        destructive: true,
                    },
                ]}
                align="end"
            />
            <RemoveMfaConfirmationModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                methodId={methodId}
                accessControl={accessControl}
                userId={userId}
            />
        </>
    );
};
